import React from 'react';

const AYUR_GREEN = '#6B8E23';
const AYUR_GOLD = '#D4AF37';
const AYUR_WARM = '#CD8B65';
const AYUR_LIGHT_BG = '#FEF7F0';

const About = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [currentLeftSlide, setCurrentLeftSlide] = React.useState(0);
  const [currentRightSlide, setCurrentRightSlide] = React.useState(0);
  const [showProgramModal, setShowProgramModal] = React.useState(false);

  const retreatDays = [
    {
      day: 'DAY 1',
      emoji: '🏔',
      theme: 'Arrival & Grounding',
      subtheme: 'Welcome to the Himalayas',
      goal: 'Ground your energy & begin your healing journey',
      activities: [
        'Airport pickup & welcome herbal drink',
        'Check-in & room orientation',
        'Ayurvedic consultation & Dosha analysis',
        'Personalized treatment planning',
        'Sunset walk to Ganga Ghat',
        'Opening intention ceremony by the river',
        'Light sattvic dinner'
      ],
      timed: false,
      color: '#6B8E23'
    },
    {
      day: 'DAY 2',
      emoji: '🌿',
      theme: 'Detox & Nervous System Reset',
      subtheme: 'Cleanse & Relax',
      goal: 'Release stress & activate circulation',
      activities: [
        { time: '6:30 AM', act: 'Pranayama & gentle Hatha yoga' },
        { time: '8:00 AM', act: 'Herbal detox tea' },
        { time: '9:30 AM', act: 'Abhyanga (full body oil massage)' },
        { time: '11:00 AM', act: 'Steam therapy (Swedana)' },
        { time: '1:00 PM', act: 'Detox Ayurvedic lunch' },
        { time: '4:00 PM', act: 'Yoga Nidra' },
        { time: '6:00 PM', act: 'Ganga Aarti experience' },
        { time: '7:30 PM', act: 'Light dinner' }
      ],
      timed: true,
      color: '#CD8B65'
    },
    {
      day: 'DAY 3',
      emoji: '🌊',
      theme: 'Waterfall Trek & Nature Healing',
      subtheme: 'Connect with Nature',
      goal: 'Reconnect with nature & awaken joy',
      activities: [
        { time: '6:30 AM', act: 'Sunrise meditation' },
        { time: '8:00 AM', act: 'Breakfast' },
        { time: '9:30 AM', act: 'Guided trek to Himalayan waterfall' },
        { time: '', act: 'Forest breathing session (Prakriti connection)' },
        { time: '', act: 'Mindful silence practice' },
        { time: '', act: 'Group activities & light wellness games' },
        { time: '', act: 'Natural foot immersion in waterfall' },
        { time: '2:00 PM', act: 'Return & lunch' },
        { time: '5:00 PM', act: 'Evening stretching & relaxation' },
        { time: '7:00 PM', act: 'Sound Healing Session (Tibetan bowls & mantra vibrations)' }
      ],
      timed: true,
      color: '#4A90D9'
    },
    {
      day: 'DAY 4',
      emoji: '🌿',
      theme: 'Panchakarma & Deep Emotional Release',
      subtheme: 'Internal Cleansing',
      goal: 'Remove toxins & balance doshas',
      activities: [
        { time: '6:30 AM', act: 'Yoga for digestion' },
        { time: '9:30 AM', act: 'Customized Panchakarma therapy (Basti / Nasya / Virechana as prescribed)' },
        { time: '1:00 PM', act: 'Healing khichdi meal' },
        { time: '4:00 PM', act: 'Ayurvedic lifestyle class' },
        { time: '6:00 PM', act: 'Meditation at Ganga Ghat' },
        { time: '7:30 PM', act: 'Herbal dinner' }
      ],
      timed: true,
      color: '#7B5EA7'
    },
    {
      day: 'DAY 5',
      emoji: '🔔',
      theme: 'Shirodhara & Sound Healing',
      subtheme: 'Calm the Mind',
      goal: 'Deep nervous system reset',
      activities: [
        { time: '6:30 AM', act: 'Meditation & breathwork' },
        { time: '9:30 AM', act: 'Shirodhara therapy' },
        { time: '1:00 PM', act: 'Nourishing sattvic lunch' },
        { time: '3:30 PM', act: 'Interactive Ayurvedic cooking class' },
        { time: '5:30 PM', act: 'Group bonding games & trust activities' },
        { time: '7:00 PM', act: 'Deep Sound Healing Journey (Chakra balancing, mantra chanting, vibration therapy)' }
      ],
      timed: true,
      color: '#D4AF37'
    },
    {
      day: 'DAY 6',
      emoji: '🕉',
      theme: 'Ganga Wisdom & Integration',
      subtheme: 'Spiritual Immersion',
      goal: 'Integrate healing into daily life',
      activities: [
        { time: '6:00 AM', act: 'Sunrise yoga at Ganga Ghat' },
        { time: '', act: 'Philosophy talk: Ayurveda & Yogic lifestyle' },
        { time: '', act: 'Guided mantra chanting' },
        { time: '', act: 'River gratitude ritual' },
        { time: '12:30 PM', act: 'Lunch' },
        { time: '3:00 PM', act: 'One-on-one doctor follow-up' },
        { time: '4:30 PM', act: 'Herbal formulation guidance' },
        { time: '6:00 PM', act: 'Sharing circle & reflection' },
        { time: '7:30 PM', act: 'Celebration dinner' }
      ],
      timed: true,
      color: '#E86A4A'
    },
    {
      day: 'DAY 7',
      emoji: '🌸',
      theme: 'Completion & Departure',
      subtheme: 'Transformation & Blessings',
      goal: 'Return home renewed, balanced & empowered',
      activities: [
        'Morning gratitude meditation',
        'Personalized wellness plan',
        'Herbal take-home kit',
        'Certificate of completion',
        'Farewell breakfast',
        'Airport drop'
      ],
      timed: false,
      color: '#6B8E23'
    }
  ];

  const extraActivities = [
    'Waterfall nature trek',
    'Daily yoga & meditation',
    'Sound healing therapy',
    'Panchakarma treatments',
    'Ganga Ghat spiritual class',
    'Ayurvedic cooking class',
    'Group wellness games & activities',
    'Cultural immersion experience'
  ];

  const mobileCarouselImages = [
    { src: '/about4.webp', alt: 'Group yoga class' },
    { src: '/about2.webp', alt: 'Woman in yoga stretch' },
    { src: '/about6.jpeg', alt: 'Spa and massage treatment' },
    { src: '/about5.jpeg', alt: 'Himalayan sanctuary views' }
  ];

  const leftCarouselImages = [
    { src: '/about4.webp', alt: 'Group yoga class' },
    { src: '/about5.jpeg', alt: 'Spa and massage treatment' }
  ];

  const rightCarouselImages = [
    { src: '/about2.webp', alt: 'Woman in yoga stretch' },
    { src: '/about6.jpeg', alt: 'Himalayan sanctuary views' }
  ];

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % mobileCarouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + mobileCarouselImages.length) % mobileCarouselImages.length);
  };

  const nextLeftSlide = () => {
    setCurrentLeftSlide((prev) => (prev + 1) % leftCarouselImages.length);
  };

  const prevLeftSlide = () => {
    setCurrentLeftSlide((prev) => (prev - 1 + leftCarouselImages.length) % leftCarouselImages.length);
  };

  const nextRightSlide = () => {
    setCurrentRightSlide((prev) => (prev + 1) % rightCarouselImages.length);
  };

  const prevRightSlide = () => {
    setCurrentRightSlide((prev) => (prev - 1 + rightCarouselImages.length) % rightCarouselImages.length);
  };

  return (
    <>
      {/* Main About Section */}
      <section id="about" style={{
        position: 'relative',
        padding: isMobile ? '3rem 1rem' : '6rem 2rem',
        background: 'linear-gradient(135deg, #FEF7F0 0%, #FFF9F3 50%, #FAF3EB 100%)',
        overflow: 'hidden',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          position: 'relative'
        }}>
          {/* Heading */}
          <h2 style={{
            fontSize: isMobile ? '2rem' : '3rem',
            fontWeight: 900,
            background: `linear-gradient(135deg, ${AYUR_GREEN}, ${AYUR_WARM})`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            marginBottom: isMobile ? '2.5rem' : '4rem',
            textAlign: 'center',
            letterSpacing: '-0.02em'
          }}>
            About Our Retreat
          </h2>

          {/* Main Content Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '300px 1fr 300px',
            gap: isMobile ? '2rem' : '3rem',
            alignItems: 'center',
            position: 'relative'
          }}>
            {/* Left Image Carousel */}
            {!isMobile && (
              <div className="left-image" style={{
                position: 'sticky',
                top: '2rem',
                height: 'fit-content'
              }}>
                <div style={{
                  width: '100%',
                  height: '360px',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(205, 139, 101, 0.2)',
                  backgroundColor: '#e8f0dc',
                  border: `1px solid ${AYUR_GOLD}30`,
                  position: 'relative'
                }}>
                  {/* Images with absolute positioning */}
                  {leftCarouselImages.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: currentLeftSlide === index ? 1 : 0,
                        transition: 'opacity 0.5s ease-in-out',
                        pointerEvents: currentLeftSlide === index ? 'auto' : 'none'
                      }}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          display: 'block'
                        }}
                      />
                    </div>
                  ))}

                  {/* Navigation Arrows */}
                  <button
                    onClick={prevLeftSlide}
                    style={{
                      position: 'absolute',
                      left: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(255, 255, 255, 0.85)',
                      border: 'none',
                      borderRadius: '50%',
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      color: AYUR_GREEN,
                      fontWeight: 'bold',
                      zIndex: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = AYUR_GREEN;
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
                      e.currentTarget.style.color = AYUR_GREEN;
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}>
                    ←
                  </button>

                  <button
                    onClick={nextLeftSlide}
                    style={{
                      position: 'absolute',
                      right: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(255, 255, 255, 0.85)',
                      border: 'none',
                      borderRadius: '50%',
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      color: AYUR_GREEN,
                      fontWeight: 'bold',
                      zIndex: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = AYUR_GREEN;
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
                      e.currentTarget.style.color = AYUR_GREEN;
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}>
                    →
                  </button>

                  {/* Dot Indicators */}
                  <div style={{
                    position: 'absolute',
                    bottom: '0.75rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: '0.3rem',
                    zIndex: 10
                  }}>
                    {leftCarouselImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentLeftSlide(index)}
                        style={{
                          width: currentLeftSlide === index ? '20px' : '8px',
                          height: '8px',
                          borderRadius: '4px',
                          border: 'none',
                          backgroundColor: currentLeftSlide === index ? AYUR_GOLD : 'rgba(255, 255, 255, 0.5)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'
                        }}
                        onMouseEnter={(e) => {
                          if (currentLeftSlide !== index) {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (currentLeftSlide !== index) {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Center Content */}
            <div style={{
              textAlign: 'center',
              padding: isMobile ? '0' : '2rem',
              zIndex: 2
            }}>
              {/* Main Tagline */}
              <p style={{
                fontSize: isMobile ? '1rem' : '1.25rem',
                lineHeight: '1.7',
                color: '#6B7280',
                marginBottom: '1rem',
                fontWeight: 500,
                letterSpacing: '0.5px'
              }}>
                At <span style={{ fontWeight: 900, background: `linear-gradient(135deg, ${AYUR_GREEN}, ${AYUR_WARM})`, backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent' }}>Divineretreat Retreat</span>
              </p>

              {/* Subheading */}
              <h3 style={{
                fontSize: isMobile ? '1.15rem' : '1.4rem',
                lineHeight: '1.6',
                color: '#1f2937',
                marginBottom: '1.5rem',
                fontWeight: 700,
                letterSpacing: '-0.01em'
              }}>
                Experience Authentic Healing in the Heart of Rishikesh
              </h3>

              {/* Description */}
              <p style={{
                fontSize: isMobile ? '0.95rem' : '1.05rem',
                lineHeight: '1.75',
                color: '#4b5563',
                marginBottom: '2rem',
                fontWeight: 400
              }}>
                Nestled in the serene foothills of the Himalayas, our retreat sanctuary combines 5,000 years of Ayurvedic wisdom with modern wellness practices. We've created a transformative space where ancient healing traditions meet contemporary comfort.
              </p>

              {/* Service Pills with Enhanced Colors */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? '0.6rem' : '0.8rem',
                flexWrap: 'wrap',
                marginBottom: '2.5rem'
              }}>
                {[
                  { name: 'Yoga & Meditation', icon: '🧘' },
                  { name: 'Panchakarma', icon: '💆' },
                  { name: 'Ayurvedic Therapy', icon: '🌿' }
                ].map((service, i) => (
                  <span key={i} style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    padding: isMobile ? '0.6rem 1rem' : '0.75rem 1.3rem',
                    background: `linear-gradient(135deg, ${AYUR_GOLD}20, ${AYUR_WARM}15)`,
                    borderRadius: '24px',
                    color: AYUR_GREEN,
                    fontWeight: 700,
                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                    letterSpacing: '0.3px',
                    border: `1.5px solid ${AYUR_GOLD}40`,
                    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.target.style.background = `linear-gradient(135deg, ${AYUR_GOLD}, ${AYUR_WARM})`;
                      e.target.style.color = 'white';
                      e.target.style.transform = 'translateY(-3px)';
                      e.target.style.boxShadow = `0 10px 30px ${AYUR_WARM}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = `linear-gradient(135deg, ${AYUR_GOLD}20, ${AYUR_WARM}15)`;
                      e.target.style.color = AYUR_GREEN;
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                    <span>{service.icon}</span> {service.name}
                  </span>
                ))}
              </div>

              {/* Key Benefits */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                gap: '1.25rem',
                marginBottom: '2rem'
              }}>
                {[
                  { label: '7 Days', value: 'Transformative Program', clickable: true },
                  { label: 'Expert', value: 'Ayurvedic Practitioners', clickable: false },
                  { label: 'Himalayan', value: 'Mountain Sanctuary', clickable: false }
                ].map((item, i) => (
                  <div key={i}
                    onClick={() => item.clickable && setShowProgramModal(true)}
                    style={{
                      padding: '1.25rem',
                      backgroundColor: item.clickable ? `${AYUR_GREEN}10` : 'rgba(212, 175, 55, 0.08)',
                      borderRadius: '16px',
                      border: item.clickable ? `1.5px solid ${AYUR_GREEN}50` : `1px solid ${AYUR_GOLD}30`,
                      transition: 'all 0.3s ease',
                      cursor: item.clickable ? 'pointer' : 'default',
                      position: 'relative'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = item.clickable ? `${AYUR_GREEN}20` : `${AYUR_GOLD}15`;
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = item.clickable ? `0 8px 25px ${AYUR_GREEN}25` : 'none';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = item.clickable ? `${AYUR_GREEN}10` : 'rgba(212, 175, 55, 0.08)';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {item.clickable && (
                      <div style={{
                        position: 'absolute',
                        top: '0.5rem',
                        right: '0.5rem',
                        fontSize: '0.65rem',
                        background: `linear-gradient(135deg, ${AYUR_GREEN}, ${AYUR_WARM})`,
                        color: 'white',
                        padding: '0.15rem 0.45rem',
                        borderRadius: '20px',
                        fontWeight: 700,
                        letterSpacing: '0.3px'
                      }}>View Details</div>
                    )}
                    <div style={{ fontWeight: 900, fontSize: '0.85rem', color: AYUR_WARM, letterSpacing: '0.5px', marginBottom: '0.5rem' }}>
                      {item.label}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: '0.95rem', color: AYUR_GREEN }}>
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              {/* Extended Description */}
              <p style={{
                fontSize: isMobile ? '0.95rem' : '1.05rem',
                lineHeight: '1.75',
                color: '#4b5563',
                fontWeight: 400
              }}>
                Our team of certified Ayurvedic doctors, yoga masters, and wellness experts works exclusively with small batches of guests—never more than 12—to deliver highly personalized healing journeys that transform body, mind, and spirit.
              </p>
            </div>

            {/* Right Image Carousel */}
            {!isMobile && (
              <div className="right-image" style={{
                position: 'sticky',
                top: '2rem',
                height: 'fit-content'
              }}>
                <div style={{
                  width: '100%',
                  height: '360px',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(205, 139, 101, 0.2)',
                  backgroundColor: '#e8f0dc',
                  border: `1px solid ${AYUR_GOLD}30`,
                  position: 'relative'
                }}>
                  {/* Images with absolute positioning */}
                  {rightCarouselImages.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: currentRightSlide === index ? 1 : 0,
                        transition: 'opacity 0.5s ease-in-out',
                        pointerEvents: currentRightSlide === index ? 'auto' : 'none'
                      }}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          display: 'block'
                        }}
                      />
                    </div>
                  ))}

                  {/* Navigation Arrows */}
                  <button
                    onClick={prevRightSlide}
                    style={{
                      position: 'absolute',
                      left: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(255, 255, 255, 0.85)',
                      border: 'none',
                      borderRadius: '50%',
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      color: AYUR_GREEN,
                      fontWeight: 'bold',
                      zIndex: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = AYUR_GREEN;
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
                      e.currentTarget.style.color = AYUR_GREEN;
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}>
                    ←
                  </button>

                  <button
                    onClick={nextRightSlide}
                    style={{
                      position: 'absolute',
                      right: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(255, 255, 255, 0.85)',
                      border: 'none',
                      borderRadius: '50%',
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      color: AYUR_GREEN,
                      fontWeight: 'bold',
                      zIndex: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = AYUR_GREEN;
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
                      e.currentTarget.style.color = AYUR_GREEN;
                      e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}>
                    →
                  </button>

                  {/* Dot Indicators */}
                  <div style={{
                    position: 'absolute',
                    bottom: '0.75rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: '0.3rem',
                    zIndex: 10
                  }}>
                    {rightCarouselImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentRightSlide(index)}
                        style={{
                          width: currentRightSlide === index ? '20px' : '8px',
                          height: '8px',
                          borderRadius: '4px',
                          border: 'none',
                          backgroundColor: currentRightSlide === index ? AYUR_GOLD : 'rgba(255, 255, 255, 0.5)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'
                        }}
                        onMouseEnter={(e) => {
                          if (currentRightSlide !== index) {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (currentRightSlide !== index) {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Mobile Carousel */}
            {isMobile && (
              <div style={{
                position: 'relative',
                width: '100%',
                height: '280px',
                overflow: 'hidden',
                borderRadius: '20px',
                boxShadow: '0 12px 30px rgba(205, 139, 101, 0.15)',
                backgroundColor: '#e8f0dc',
                border: `1px solid ${AYUR_GOLD}20`
              }}>
                {/* Images with absolute positioning */}
                {mobileCarouselImages.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      opacity: currentSlide === index ? 1 : 0,
                      transition: 'opacity 0.5s ease-in-out',
                      pointerEvents: currentSlide === index ? 'auto' : 'none'
                    }}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block'
                      }}
                    />
                  </div>
                ))}

                {/* Mobile Navigation Arrows */}
                <button
                  onClick={prevSlide}
                  style={{
                    position: 'absolute',
                    left: '0.75rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '36px',
                    height: '36px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: 'none',
                    borderRadius: '50%',
                    fontSize: '1.25rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    color: AYUR_GREEN,
                    fontWeight: 'bold',
                    zIndex: 10,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = AYUR_GREEN;
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.currentTarget.style.color = AYUR_GREEN;
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }}>
                  ←
                </button>

                <button
                  onClick={nextSlide}
                  style={{
                    position: 'absolute',
                    right: '0.75rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '36px',
                    height: '36px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: 'none',
                    borderRadius: '50%',
                    fontSize: '1.25rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    color: AYUR_GREEN,
                    fontWeight: 'bold',
                    zIndex: 10,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = AYUR_GREEN;
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.currentTarget.style.color = AYUR_GREEN;
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }}>
                  →
                </button>

                {/* Mobile Dot Indicators */}
                <div style={{
                  position: 'absolute',
                  bottom: '0.75rem',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'flex',
                  gap: '0.4rem',
                  zIndex: 10
                }}>
                  {mobileCarouselImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      style={{
                        width: currentSlide === index ? '24px' : '10px',
                        height: '10px',
                        borderRadius: '5px',
                        border: 'none',
                        backgroundColor: currentSlide === index ? AYUR_GOLD : 'rgba(255, 255, 255, 0.6)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        if (currentSlide !== index) {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (currentSlide !== index) {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 7-Day Program Modal */}
      {showProgramModal && (
        <div
          onClick={() => setShowProgramModal(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.75)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            padding: isMobile ? '0' : '2rem',
            backdropFilter: 'blur(6px)',
            overflowY: 'auto'
          }}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#FFFDF9',
              borderRadius: isMobile ? '20px 20px 0 0' : '28px',
              width: '100%',
              maxWidth: '860px',
              maxHeight: isMobile ? '95vh' : '90vh',
              overflowY: 'auto',
              marginTop: isMobile ? 'auto' : '0',
              boxShadow: '0 30px 80px rgba(0,0,0,0.35)',
              fontFamily: "'Inter', sans-serif"
            }}>

            {/* Modal Header */}
            <div style={{
              background: `linear-gradient(135deg, ${AYUR_GREEN} 0%, #5a7a1e 50%, ${AYUR_WARM} 100%)`,
              padding: isMobile ? '2rem 1.5rem 1.5rem' : '2.5rem 3rem 2rem',
              borderRadius: isMobile ? '20px 20px 0 0' : '28px 28px 0 0',
              position: 'relative'
            }}>
              <button
                onClick={() => setShowProgramModal(false)}
                style={{
                  position: 'absolute',
                  top: '1.25rem',
                  right: '1.25rem',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: 'white',
                  width: '38px',
                  height: '38px',
                  borderRadius: '50%',
                  fontSize: '1.3rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.35)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}>
                ✕
              </button>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.5rem', letterSpacing: '2px', textTransform: 'uppercase' }}>
                Divine Retreat – Rishikesh
              </p>
              <h2 style={{ color: 'white', fontSize: isMobile ? '1.6rem' : '2.2rem', fontWeight: 900, margin: '0 0 0.75rem 0', lineHeight: 1.2 }}>
                7-Day Transformative Ayurvedic Retreat
              </h2>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                {['7 Days', '15+ Treatments', 'Max 12 Guests', 'Certificate Included'].map((tag, i) => (
                  <span key={i} style={{
                    background: 'rgba(255,255,255,0.18)',
                    color: 'white',
                    padding: '0.3rem 0.85rem',
                    borderRadius: '20px',
                    fontSize: '0.82rem',
                    fontWeight: 600,
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}>{tag}</span>
                ))}
              </div>
            </div>

            {/* Days Content */}
            <div style={{ padding: isMobile ? '1.5rem' : '2.5rem 3rem' }}>
              {retreatDays.map((dayInfo, di) => (
                <div key={di} style={{
                  marginBottom: '2rem',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  border: `1px solid ${dayInfo.color}25`,
                  boxShadow: `0 4px 18px ${dayInfo.color}12`
                }}>
                  {/* Day Header */}
                  <div style={{
                    background: `linear-gradient(135deg, ${dayInfo.color}15, ${dayInfo.color}08)`,
                    borderBottom: `2px solid ${dayInfo.color}30`,
                    padding: '1rem 1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <span style={{ fontSize: '1.75rem' }}>{dayInfo.emoji}</span>
                    <div>
                      <div style={{ fontSize: '0.75rem', fontWeight: 800, color: dayInfo.color, letterSpacing: '2px', textTransform: 'uppercase' }}>
                        {dayInfo.day}
                      </div>
                      <div style={{ fontSize: isMobile ? '1rem' : '1.15rem', fontWeight: 800, color: '#1f2937' }}>
                        {dayInfo.theme}
                      </div>
                      <div style={{ fontSize: '0.8rem', color: '#6B7280', fontWeight: 600, fontStyle: 'italic' }}>
                        Theme: {dayInfo.subtheme}
                      </div>
                    </div>
                  </div>

                  {/* Activities */}
                  <div style={{ padding: '1rem 1.5rem', backgroundColor: 'white' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                      {dayInfo.timed
                        ? dayInfo.activities.map((a, ai) => (
                          <div key={ai} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                            {a.time ? (
                              <span style={{
                                minWidth: '70px',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                color: dayInfo.color,
                                backgroundColor: `${dayInfo.color}12`,
                                padding: '0.2rem 0.5rem',
                                borderRadius: '8px',
                                textAlign: 'center',
                                marginTop: '0.1rem',
                                flexShrink: 0
                              }}>{a.time}</span>
                            ) : (
                              <span style={{ minWidth: '70px', flexShrink: 0 }}
                              ><span style={{ color: dayInfo.color, fontWeight: 700, marginLeft: '0.5rem' }}>•</span></span>
                            )}
                            <span style={{ fontSize: '0.9rem', color: '#374151', lineHeight: 1.5 }}>{a.act}</span>
                          </div>
                        ))
                        : dayInfo.activities.map((a, ai) => (
                          <div key={ai} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start' }}>
                            <span style={{ color: dayInfo.color, fontWeight: 700, fontSize: '1.1rem', marginTop: '-0.05rem' }}>•</span>
                            <span style={{ fontSize: '0.9rem', color: '#374151', lineHeight: 1.5 }}>{a}</span>
                          </div>
                        ))
                      }
                    </div>
                    {/* Goal Banner */}
                    <div style={{
                      marginTop: '1rem',
                      padding: '0.6rem 1rem',
                      background: `linear-gradient(135deg, ${dayInfo.color}15, ${dayInfo.color}08)`,
                      borderRadius: '10px',
                      borderLeft: `3px solid ${dayInfo.color}`,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span style={{ fontSize: '1rem' }}>✨</span>
                      <span style={{ fontSize: '0.85rem', fontWeight: 700, color: dayInfo.color }}>
                        Goal: {dayInfo.goal}
                      </span>
                    </div>
                  </div>
                </div>
              ))}

              {/* Extra Activities */}
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                border: `1px solid ${AYUR_GOLD}40`,
                background: `linear-gradient(135deg, ${AYUR_GOLD}10, ${AYUR_WARM}08)`
              }}>
                <div style={{
                  padding: '1rem 1.5rem',
                  borderBottom: `2px solid ${AYUR_GOLD}40`,
                  background: `linear-gradient(135deg, ${AYUR_GOLD}20, ${AYUR_WARM}12)`
                }}>
                  <div style={{ fontSize: '0.75rem', fontWeight: 800, color: AYUR_WARM, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Included Throughout</div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 800, color: '#1f2937' }}>🎯 Extra Activities Included</div>
                </div>
                <div style={{ padding: '1rem 1.5rem', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: '0.5rem' }}>
                  {extraActivities.map((act, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <span style={{ color: AYUR_GREEN, fontWeight: 700 }}>✔</span>
                      <span style={{ fontSize: '0.9rem', color: '#374151' }}>{act}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowProgramModal(false)}
                style={{
                  marginTop: '2rem',
                  width: '100%',
                  padding: '1rem',
                  background: `linear-gradient(135deg, ${AYUR_GREEN}, ${AYUR_WARM})`,
                  color: 'white',
                  border: 'none',
                  borderRadius: '14px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  letterSpacing: '0.5px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = `0 10px 30px ${AYUR_GREEN}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                Close Program Details
              </button>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default About;
